module.exports = __webpack_public_path__ + "static/media/7_l_komod_2.76_53.7.ceea6b92.png";